import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Col, FormWrapper, Label, Row, TargetStatus } from 'virtues-bootstrap';
import * as Roles from 'constants/userRoles';
import s from './styles.module.scss';

const MedicalTherapyInfo = ({
  doctorName,
  clinicName,
  clinicPhone,
  comments,
  reviewedDateTime,
  status,
  statusText,
  t,
  role,
}) => (
  <>
    {role !== Roles.PATIENT ? (
      <FormWrapper
        title={t('reports.guidelineDirectedMedicalTherapy')}
        data-test="deviceStatusInfo"
      >
        <div className={s.deviceStatus}>
          <div className={s.deviceStatusIndicator}>
            <TargetStatus variant={status} />
          </div>
          <div className={s.deviceStatusContent}>{statusText}</div>
        </div>
        <div className={s.deviceStatusInfo}>
          <Row className={s.rowWithMargin}>
            <Col sm={5} md={5} lg={4}>
              <Label>{t('reports.comments')}</Label>
            </Col>
            <Col sm={7} md={6} lg={5}>
              <div>{comments}</div>
            </Col>
          </Row>
          <Row className={s.rowWithMargin}>
            <Col sm={5} md={5} lg={4}>
              <Label>{t('reports.reviewedBy')}</Label>
            </Col>
            <Col sm={7} md={6} lg={5}>
              <div>{doctorName}</div>
              <div>{clinicName || t('reports.missingClinic')}</div>
              <div>{reviewedDateTime}</div>
            </Col>
          </Row>
        </div>
        <p>
          <strong>
            {t('reports.additionalQuestionsMsg', {
              clinicPhone: clinicPhone || t('reports.numberNotListedInLighter'),
            })}
          </strong>
        </p>
      </FormWrapper>
    ) : (
      <FormWrapper title="" data-test="deviceStatusInfo">
        <Row className={s.rowWithMargin}>
          <Col sm={5} md={5} lg={4}>
            <Label>{t('reports.reviewedBy')}</Label>
          </Col>
          <Col sm={7} md={6} lg={5}>
            <div>{doctorName}</div>
            <div>{clinicName || t('reports.missingClinic')}</div>
            <div>{reviewedDateTime}</div>
          </Col>
        </Row>
        <p>
          <strong>
            {t('reports.additionalQuestionsMsg', {
              clinicPhone: clinicPhone || t('reports.numberNotListedInLighter'),
            })}
          </strong>
        </p>
      </FormWrapper>
    )}
  </>
);

MedicalTherapyInfo.propTypes = {
  doctorName: PropTypes.string,
  clinicName: PropTypes.string,
  clinicPhone: PropTypes.string.isRequired,
  comments: PropTypes.string.isRequired,
  reviewedDateTime: PropTypes.string.isRequired,
  status: PropTypes.oneOf(['success', 'warning', 'danger', 'notApplicable']).isRequired,
  statusText: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired,
};

MedicalTherapyInfo.defaultProps = {
  clinicName: null,
  doctorName: null,
};

export default withTranslation()(MedicalTherapyInfo);
